<template>
  <div class="relative">
    <div v-if="deviceList.length > 1" class="flex w-92 bg-neutral-light-default m-auto rounded-7xl">
      <Header
        v-for="item in deviceList"
        :key="item.id"
        :name="item.name"
        :icon="item.icon"
        class="cursor-pointer w-fit"
        :class="[item.id === modelValue.id ? `bg-glass60` : 'bg-transparent']"
        @close="$emit('close')"
        @click="emit('update:modelValue', item)"
      />
    </div>
    <Header
      v-else
      :name="modelValue.name"
      :icon="modelValue.icon"
      class="w-92 bg-neutral-light-default m-auto rounded-7xl"
      @close="$emit('close')"
    ></Header>
    <div class="top-0 right-0 absolute">
      <Button color="normal" shape="circle" size="icon-sm" @click="close">
        <Icon icon="Status-Wireframe-Close"></Icon>
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import Header from './Header.vue'
  import { DeviceItem } from '@/stores'
  import { Button, Icon } from '@rapoo/element'

  const props = defineProps<{
    deviceList: DeviceItem[]
    modelValue: DeviceItem
  }>()

  const emit = defineEmits<{
    (e: 'close'): void
    (e: 'update:modelValue', value: DeviceItem): void
  }>()
  const close = () => {
    emit('close')
  }
</script>
